export default {"src":"/_next/static/media/minidiftman-happy.da4c99d1.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};